
import { CREATE_ADMIN_FAILURE, CREATE_ADMIN_REQUEST, CREATE_ADMIN_SUCCESS, DELETE_ADMIN_FAILURE, DELETE_ADMIN_REQUEST, DELETE_ADMIN_SUCCESS, EDIT_ADMIN_FAILURE, EDIT_ADMIN_REQUEST, EDIT_ADMIN_SUCCESS, GET_ADMIN_FAILURE, GET_ADMIN_REQUEST, GET_ADMIN_SUCCESS } from "./adminTypes";

const initialStateForAdmin = {
    loading: false,
    admins: [],
    error: "",
  };
  
  const adminReducer = (state = initialStateForAdmin, action) => {
    switch (action.type) {
      case GET_ADMIN_REQUEST:
        return {
          ...state,
          loading: true,
        };
      case GET_ADMIN_SUCCESS:
        return {
          loading: false,
          admins: action.payload,
          error: "",
        };
      case GET_ADMIN_FAILURE:
        return {
          loading: false,
          admins: [],
          error: action.payload,
        };
      default:
        return state;
    }
  };

  
const initialStateForCreateAdmin = {
    loading: false,
    create: {},
    error: "",
  };
  
  const createAdminReducer = (state = initialStateForCreateAdmin, action) => {
    switch (action.type) {
      case CREATE_ADMIN_REQUEST:
        return {
          ...state,
          loading: true,
        };
      case CREATE_ADMIN_SUCCESS:
        return {
          loading: true,
          create: action.payload,
          error: "",
        };
      case CREATE_ADMIN_FAILURE:
        return {
          loading: false,
          create: {},
          error: action.payload,
        };
      default:
        return state;
    }
  };
  
  const initialStateForEdit = {
    loading: false,
    edit: {},
    error: "",
  };
  
  const editAdminReducer = (state = initialStateForEdit, action) => {
    switch (action.type) {
      case EDIT_ADMIN_REQUEST:
        return {
          ...state,
          loading: true,
        };
      case EDIT_ADMIN_SUCCESS:
        return {
          loading: true,
          edit: action.payload,
          error: "",
        };
      case EDIT_ADMIN_FAILURE:
        return {
          loading: false,
          edit: {},
          error: action.payload,
        };
      default:
        return state;
    }
  };

  
const initialStateForDelete = {
    loading: false,
    deleteAdmin: {},
    error: "",
  };
  
  const deleteAdminReducer = (state = initialStateForDelete, action) => {
    switch (action.type) {
      case DELETE_ADMIN_REQUEST:
        return {
          ...state,
          loading: true,
        };
      case DELETE_ADMIN_SUCCESS:
        return {
          loading: false,
          deleteAdmin: action.payload,
          error: "",
        };
      case DELETE_ADMIN_FAILURE:
        return {
          loading: false,
          deleteAdmin: {},
          error: action.payload,
        };
      default:
        return state;
    }
  };
   
  export {
    adminReducer,
    createAdminReducer,
    editAdminReducer,
    deleteAdminReducer
  };
  